// 德语
export default {
  Login: {
    Title: "Melden Sie sich bei Ihrem Konto an",
    describe:
      "Bitte melden Sie sich an oder erstellen Sie ein Konto, um zu beginnen.",
    Google: "Mit Google fortfahren",
    Apple: "Mit Apple fortfahren",
    or: "ODER",
    Emailplaceholder: "E-Mail-Adresse",
    Passwordplaceholder: "Passwort",
    Login: "Anmelden",
    forgot: "Passwort vergessen?",
    notAccount: "Haben Sie noch kein Fineshare-Konto?",
    Signup: "Registrieren",
    InvalidEmail: "Ungültiges E-Mail-Format.",
    InvalidPassword: "Das Passwort sollte mindestens 6 Zeichen lang sein.",
    loading: "Lädt...",
    login: "Anmelden",
    errorText:
      "Anmeldung fehlgeschlagen, bitte überprüfen Sie Ihren Benutzernamen und Passwort",
  },
  signup: {
    Title: "Erstellen Sie Ihr Konto",
    describe: "Erstellen Sie in wenigen Sekunden Ihr Fineshare-Konto.",
    Google: "Mit Google registrieren",
    Apple: "Mit Apple registrieren",
    or: "ODER",
    Emailplaceholder: "E-Mail-Adresse eingeben",
    Passwordplaceholder: "Geben Sie ein 6-stelliges Passwort ein",
    Already: "Haben Sie bereits ein Konto?",
    Login: "Anmelden",
    By: "Durch die Erstellung eines Kontos stimme ich zu, dass ich die",
    Privacy: "Datenschutzrichtlinie",
    Terms: "Nutzungsbedingungen.",
    and: "und",
    signupText: "Erstellen Sie Ihr Konto",
    InvalidEmail: "Ungültiges E-Mail-Format.",
    InvalidPassword: "Das Passwort sollte mindestens 6 Zeichen lang sein.",
    loading: "Lädt...",
    passwordError: "Die E-Mail-Adresse wurde bereits registriert",
    again:
      "Sie stellen zu viele Anfragen, bitte versuchen Sie es später noch einmal",
    Registration:
      "Registrierung fehlgeschlagen, bitte überprüfen Sie Ihre E-Mail-Adresse und Passwort.",
    hasRegistered: "Die E-Mail-Adresse wurde bereits registriert",
  },
  Home: {
    Welcome: "Willkommen im Fineshare-Konto-Center",
  },
};
